import * as React from 'react';
import './_UnreadCounter.scss';
import { CLASS_UNREAD_COUNTER, MAX_COUNT, MAX_COUNT_LABEL } from './constants';
import { EUnreadCounterSize, IUnreadCounterProps } from './types';
import { Tooltip } from 'kui';

export const UnreadCounter = ({
    count,
    size = EUnreadCounterSize.BASE,
    tooltip,
    onClick,
}: IUnreadCounterProps) => {
    const className = CLASS_UNREAD_COUNTER;

    const counter = <span
        className={`
            ${className}
            ${className}--${size.toLowerCase()}
            ${className + '--' + (!!count ? 'show' : 'hide')}
            ${count >= MAX_COUNT ? className + '--big' : ''}
        `}
        onClick={(event) => {
            if (onClick) onClick(event);
        }}
    >
        {count < MAX_COUNT ? count : MAX_COUNT_LABEL}
    </span>;

    return tooltip ? <Tooltip {...tooltip}>{counter}</Tooltip> : counter;
}
